export const HEADER_SCROLL_OFFSET = -80
export const HEADER_SCROLL_OFFSET_MOBILE = -80
export const HEADER_SCROLL_OFFSET_DESKTOP = -110
